module.exports = __webpack_public_path__ + "static/media/logo.84287d09.svg";